<template>
    <div class="ongoing-contests-wrapper">
        <div class="ongoing-contests" :class="{ open: open }">
            <button
                v-on-click-outside="onOutsideClick"
                @click="handleCompetitionsClick"
                class="ongoing-contests__button"
            >
                <SvgIcon name="cup-star-filled" />
                <span> {{ competitionsName?.length ? competitionsName : "Probíhající soutěže" }} </span>
                <SazkaSpinLoader class="right-pos" :size="20" v-if="buttonLoader" />
                <SvgIcon v-else class="right-pos arrow" name="dropdown-down" />
            </button>
            <transition name="fade">
                <transition-group v-if="open" class="contest-links" name="fade-link" tag="div">
                    <OngoingContestsLink
                        v-for="contest in contests"
                        :key="contest.id"
                        :link-suffix="contest.slug"
                        :type="contest.type"
                        :icon="contest.icon"
                        :name="contest.name"
                        :sub-text="contest.subText"
                        :category="contest.category"
                    />
                    <OngoingContestsLink key="contests-all" type="info" icon="cup-star" name="Všechny soutěže" />
                </transition-group>
            </transition>
        </div>
    </div>
</template>

<script setup lang="ts">
import analytics from "@/shared/analytics";
import SvgIcon from "@/shared/components/atoms/SvgIcon.vue";
import { ref } from "vue";
import useSazkaContests, { contests } from "@/shared/composables/use-sazka-contests";
import useNavigation from "@/shared/composables/use-navigation";
import { vOnClickOutside } from "@vueuse/components";
import SazkaSpinLoader from "@/shared/components/atoms/SazkaSpinLoader.vue";
import { useNgSession } from "@/shared/ng/ng-session";
import OngoingContestsLink from "@/header/components/atoms/OngoingContestsLink.vue";

const { session } = useNgSession();
const { competitionsName } = useNavigation();
const { getContests } = useSazkaContests();
const open = ref(false);
const buttonLoader = ref(false);

const handleCompetitionsClick = async () => {
    if (session) {
        getContests();
    }
    if (!open.value && !contests.value.length) {
        let loaderTimeout = setTimeout(() => {
            buttonLoader.value = true;
        }, 300);

        await getContests();
        clearTimeout(loaderTimeout);
        buttonLoader.value = false;
        open.value = true;
        analytics.sendShowCompetitions();
    } else {
        open.value = !open.value;
    }
};

const onOutsideClick = () => {
    open.value = false;
};
</script>
